import React from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  label: string;
  type: string;
}

const Labels = ({ label, type }: Props) => {
  return (
    <StyledLabel>
      <div>{label}</div>
      <SpotLegend type={type}>A0</SpotLegend>
    </StyledLabel>
  );
};

const StyledLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

interface SpotProps {
  type: string;
}

const SpotLegend = styled.div<SpotProps>`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1.5rem;
  gap: 0.5rem;
  font-size: 0.875rem;
  background: ${(props) =>
    props.type === "selected"
      ? Colors.red
      : props.type === "available"
      ? Colors.aqua
      : `${Colors.aqua}88`};
  color: white;
  border-radius: 1rem;
`;

export default Labels;
